import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom';

import { AppBar, Box, Button, Icon, Toolbar, Grid, Typography, IconButton } from '@mui/material';

// import useDispatch from 'react-redux';

import CardActions from '@mui/material/CardActions';

import CardMedia from '@mui/material/CardMedia';

import Card from '@mui/material/Card';

import { Account } from '../login/Account';

import NavbarUser from '../User/NavbarUser';

import Product1 from '../Products/Pictures/green.jpg'

import SEQuoia from '../Products/Pictures/SEQuoia.jpg'

// import Pic3 from '../Products/Pictures/Pic3.jpg'

import Genesis from '../Products/Pictures/Genesis.png'

import ddseq from '../Products/Pictures/ddseq.jpg'

import { Icons } from 'react-toastify';

import logo from "./Pictures/biorad.png"

import axios from 'axios';

import PersonIcon from '@mui/icons-material/Person';

import { useNavigate } from 'react-router-dom';

import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';



export const Products = () => {

    var storedValue = sessionStorage.getItem('clickedInstrument')
    var DDSeqEnabled = JSON.parse(sessionStorage.getItem("isddSeqEnabled"))
    var GenesisEnabled = JSON.parse(sessionStorage.getItem("isGenesisEnabled"))
    var SEQuoiaEnabled = JSON.parse(sessionStorage.getItem("isSEQuoiaEnabled"))

    var adminAccess = sessionStorage.getItem("adminAccessValue") === "true";
    var ddseqAccess = sessionStorage.getItem("ddseqAccessValue") === "true";
    var GenesisAccess = sessionStorage.getItem("genesisAccessValue") === "true";
    var sequoiaAccess = sessionStorage.getItem("sequoiaAccessValue") === "true";


    let navigate = useNavigate();
    const [productAccess, setProductAccess] = useState({});

    var handleButtonClick = (buttonNumber) => {
        var buttonName = `${buttonNumber}`;
        sessionStorage.setItem('clickedInstrument', buttonName);
        //sessionStorage.setItem('clickedType', 'Product');
        sessionStorage.setItem('adminCheck', adminAccess);
    }

    const handleIconClick = () => {

        //sessionStorage.setItem("clickedType", Admin);
        sessionStorage.setItem('adminCheck', adminAccess);

    }



    return (



        <div>
            <div>
                <Account>
                    <React.Fragment>
                        <NavbarUser />
                    </React.Fragment>
                </Account>
            </div>
            { }

            <Grid container spacing={{ xs: 1, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                <Box sx={{ marginLeft: 20, marginTop: 20 }}>
                    <Card sx={{ maxWidth: 600 }}>
                        <CardMedia
                            component="img"
                            alt="Product 1"
                            height="200"
                            width="200"
                            image={ddseq}
                        />
                        <CardActions>
                            <Button component={Link} to="/dashboard" variant="contained" color="success"
                                onClick={() => handleButtonClick("ddSEQ")} sx={{ height: 50, width: 300 }}
                                // disabled={DDSeqEnabled}
                                disabled={!ddseqAccess}
                            >
                                ddSEQ
                            </Button>
                        </CardActions>
                    </Card>
                </Box>
                <Box sx={{ marginLeft: 5, marginTop: 20 }}>
                    <Card sx={{ maxWidth: 600 }}>
                        <CardMedia
                            component="img"
                            alt="Product 2"
                            height="200"
                            width="200"
                            image={Genesis}
                        />
                        <CardActions>
                            <Button component={Link} to="/genesisdashboard" variant="contained" color="success"
                                onClick={() => handleButtonClick("Genesis")} sx={{ height: 50, width: 350 }}
                                // disabled={GenesisEnabled}
                                disabled={!GenesisAccess}
                            >
                                Genesis
                            </Button>
                        </CardActions>
                    </Card>
                </Box>
                <Box sx={{ marginLeft: 5, marginTop: 20 }}>
                    <Card sx={{ maxWidth: 600 }}>
                        <CardMedia
                            component="img"
                            alt="Product 3"
                            height="200"
                            width="100"
                            image={SEQuoia}
                        />
                        <CardActions>
                            <Button component={Link} to="/dashboardsequoia" variant="contained" color="success"
                                onClick={() => handleButtonClick("SEQuoia")} sx={{ height: 50, width: 350 }}
                                // disabled={SEQuoiaEnabled}
                                disabled={!sequoiaAccess}
                            >
                                SEQuoia
                            </Button>

                        </CardActions>

                    </Card>
                </Box>
                {/* <CardActions sx={{marginTop:-20}}>
                <IconButton fontSize="large" component={Link} to="/createuser" onClick={handleIconClick} sx={{color:"blue"}}  
                disabled={!adminAccess}
                title='Create User'>
              <PersonAddAlt1Icon sx={{ height:40,width:50 }}/>
              </IconButton>    
      </CardActions> */}

            </Grid>
        </div>
    )
}